import type { IconConfig } from '../types'
import { createIconsConfig } from '../create-icons-config'

export const getIconDefaultConfig = (): IconConfig => createIconsConfig({})
